import { useState, useEffect } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { t } from "i18next";

const MapModal = ({ isOpen, onClose, onLocationSelect, isLoaded }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [addressComponent, setAddressComponent] = useState(null);
  const [address, setAddress] = useState(null);

  useEffect(() => {
    if (!isLoaded) return;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCurrentLocation({ lat: latitude, lng: longitude });
          setSelectedLocation({ lat: latitude, lng: longitude });
          fetchAddress(latitude, longitude);
        },
        (error) => {
          console.error("Error getting geolocation: ", error);
        }
      );
    }
  }, []);

  const fetchAddress = async (lat, lng) => {
    const geocoder = new window.google.maps.Geocoder();
    const latLng = new window.google.maps.LatLng(lat, lng);

    return new Promise((resolve, reject) => {
      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === "OK" && results[0]) {
          resolve(results[0]);
          setAddressComponent({ address_components: results[0]?.address_components });
          setAddress(results[0].formatted_address);
        } else {
          reject("Geocoder failed due to: " + status);
        }
      });
    });
  };

  const handleMapClick = async (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    try {
      const addressData = await fetchAddress(lat, lng);
      setSelectedLocation({ lat, lng, address: addressData.formatted_address });
    } catch (error) {
      console.error(error);
    }
  };

  const handleSaveLocation = () => {
    if (selectedLocation) {
      onLocationSelect(addressComponent, address);
      onClose();
    }
  };

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <div className={`map-modal ${isOpen ? "open" : ""}`}>
      <div className="modal-content">
        <GoogleMap
          mapContainerClassName="map-container"
          center={currentLocation || { lat: -8.4095178, lng: 115.188916 }}
          zoom={10}
          onClick={handleMapClick}
        >
          {selectedLocation && <Marker position={selectedLocation} />}
        </GoogleMap>

        <div className="button-container">
          <button type="button" className="save" onClick={handleSaveLocation}>
            <i className="fa fa-map-marker" aria-hidden="true"></i>&nbsp;
            <span>{t("use_the_current_location")}</span>
          </button>
          <button type="button" className="close" onClick={onClose}>
            <i className="fa fa-times" aria-hidden="true"></i>&nbsp;
            <span>{t("close")}</span>
          </button>
        </div>

        {address && (
          <div className="address-info">
            <strong>{addressComponent?.address_components[1]?.long_name ?? ""}</strong>
            <p>{address}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MapModal;
